import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, FlexboxGrid } from 'rsuite'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import EditFormDescriptionWidget from '../dynamicForm/EditFormDescriptionWidget'
import { cloneDeep } from 'lodash-es'

export default function ProposalAttachmentsSettingForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  setLoading = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [addNewIndex, setAddNewIndex] = useState(0)
  const [objects, setObjects] = useState([])
  const [delIds, setDelIds] = useState([])

  const valuesTxt = 'attachments'
  const delIdsTxt = 'attachmentDelIds'

  useEffect(() => {
    setObjects(_schema?.objects || [])
    setSchema(_schema)
  }, [_schema])

  const onAdd = () => {
    let _objects = cloneDeep(objects) || []

    let newObj = { ..._objects?.findLast((e) => e) }
    let newId = 'NEW_' + (addNewIndex + 1)
    if (newObj) {
      newObj.id = newId
      newObj.name = newId
      newObj.value = null
      newObj.label = 'รายการใหม่ ' + (addNewIndex + 1)
    } else {
      newObj = {
        id: newId,
        name: newId,
        label: 'รายการใหม่ ' + (addNewIndex + 1),
        value: null,
        type: 'INPUT',
        viewGoup: '1',
        EnableDel: true,
        validators: {
          type: 'REQUIRED',
          errorMessage: 'กรุณาระบุ',
        },
      }
    }

    _objects.push(newObj)
    setAddNewIndex(addNewIndex + 1)
    setObjects(_objects)
    setValue(valuesTxt, _objects)
  }

  const onRemove = (item) => {
    let _objects = cloneDeep(objects) || []

    let index = _objects?.findIndex((e) => e.name == item.name)
    _objects.splice(index, 1)
    if (!item.id.startsWith('NEW_')) {
      setDelIds([...delIds, item.id])
      setValue(delIdsTxt, [...delIds, item.id])
    }
    setObjects(_objects)
    setValue(valuesTxt, _objects)
  }

  const onChange = (index, value) => {
    let _objects = cloneDeep(objects) || []
    _objects[index].value = value
    setObjects(_objects)
    setValue(valuesTxt, _objects)
  }

  return (
    <Row>
      {schema.description && (
        <Col style={{ marginBottom: 15 }}>
          <CustomAlertMessageInfo contents={schema.description} />
        </Col>
      )}

      <Controller
        key={valuesTxt}
        name={valuesTxt}
        control={control}
        defaultValue={objects}
        value={objects}
      />
      <Controller
        key={delIdsTxt}
        name={delIdsTxt}
        control={control}
        defaultValue={delIds}
        value={delIds}
      />

      {schema.descriptionSetting && (
        <EditFormDescriptionWidget
          schema={schema.descriptionSetting}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      <FlexboxGrid>
        {schema.detail && (
          <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={24} lg={24}>
            <CKEditorFrom
              schema={schema.detail}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </FlexboxGrid.Item>
        )}

        {objects?.map((item, index) => {
          return (
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              xs={24}
              sm={24}
              md={item.sizeMdLg || 24}
              lg={item.sizeMdLg || 24}
            >
              <InputForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                onChange={(value) => {
                  onChange(index, value)
                }}
              />
              {item.enableDel && (
                <CancelButton
                  style={{ marginBottom: 10, marginTop: 10 }}
                  icon="trash-o"
                  children="ลบ"
                  onClick={() => {
                    onRemove(item)
                  }}
                />
              )}
            </FlexboxGrid.Item>
          )
        })}

        {schema.enableAdd && (
          <SaveButton
            style={{ marginBottom: 20, marginTop: 20 }}
            icon="plus"
            children="เพิ่ม"
            onClick={onAdd}
          />
        )}

        {schema.note && (
          <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={24} lg={24}>
            <CKEditorFrom
              schema={schema.note}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </FlexboxGrid.Item>
        )}
      </FlexboxGrid>
    </Row>
  )
}
